import { Link, useLocation } from "react-router-dom";

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="min-h-screen flex flex-col items-center justify-center text-center px-4 bg-background-50">
      <span className="w-16 h-16 rounded-full bg-primary-100 text-primary-600 flex items-center justify-center">
        <i className="ri-emotion-sad-line text-3xl"></i>
      </span>
      <h1 className="font-heading text-4xl md:text-6xl font-semibold text-foreground-950 mt-6">
        404
      </h1>
      <p className="text-base md:text-lg text-foreground-700 mt-3">抱歉，这个页面还没有内容</p>
      <p className="text-sm text-foreground-400 mt-2 break-all max-w-md">{location.pathname}</p>
      <div className="flex flex-wrap items-center justify-center gap-3 mt-8">
        <Link
          to="/"
          className="inline-flex items-center gap-1.5 px-5 py-2.5 rounded-md bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
        >
          <i className="ri-home-line"></i>
          返回首页
        </Link>
        <Link
          to="/category/news"
          className="inline-flex items-center gap-1.5 px-5 py-2.5 rounded-md border border-background-200 text-foreground-700 text-sm hover:border-primary-300 hover:text-primary-700 transition-colors whitespace-nowrap cursor-pointer"
        >
          <i className="ri-newspaper-line"></i>
          浏览最新资讯
        </Link>
      </div>
    </div>
  );
}